import { render, staticRenderFns } from "./publicationDetailPage.vue?vue&type=template&id=1a37b282&"
import script from "./publicationDetailPage.vue?vue&type=script&lang=js&"
export * from "./publicationDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./publicationDetailPage.vue?vue&type=style&index=0&id=1a37b282&prod&socped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports